import { CloseCircleOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { ValidationError } from "@/shared/interfaces/validation-error.interface";
import { getErrorLocation, groupErrorsBySource } from "./validationErrors.utils";
import style from "./style.module.css";

interface ValidationErrorsModalProps {
  title: string;
  errors: ValidationError[] | null;
  onClose: () => void;
}

export function ValidationErrorsModal({ title, errors, onClose }: ValidationErrorsModalProps) {
  const groupedErrors = groupErrorsBySource(errors ?? []);

  return (
    <BasicModal isModalOpen={!isEmpty(groupedErrors)} handleCancel={onClose} autoHeight={true}>
      <div className={style.container}>
        <h2 className={style.title}>{title}</h2>

        {groupedErrors.map((group) => (
          <div key={`${group.source}-${group.displayName}`} className={style.errorSection}>
            <p className={style.errorSectionTitle}>{group.displayName}</p>
            {group.errors.map((error) => {
              const location = getErrorLocation(error);
              return (
                <p
                  key={`${error.code}-${error.row ?? error.line ?? ""}-${error.message}`}
                  className={style.errorItemFail}
                >
                  <CloseCircleOutlined className={style.failIcon} />
                  {location && <strong>{location}: </strong>}
                  {error.message}
                </p>
              );
            })}
          </div>
        ))}
      </div>
    </BasicModal>
  );
}
